"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _createNamedExportFrom(obj, localName, importedName) { Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]}); }/* This is a fork of createReducer from @reduxjs/toolkit that supports
 * passing a 3rd parameter (`globalState`) to `caseReducer` to match its
 * signature with that of `BlmReducer`.
 */

var _createReducer = require('./createReducer'); _createNamedExportFrom(_createReducer, 'default', 'createReducer');
